<!-- rendering from templates -->
<div (click)="showMenu(-1, $event, '')" (mouseenter)="hideAvailableFolders()">
  <div class="panel-content" [innerHtml]="html | sanitizeHtml"></div>
  <!-- rendering from templates end -->

  <div class="anno-types">
    <div (click)="drawShapes('Point', 1)" class="closerToolTip">
      <img (click)="enableClass(1)" [ngClass]="active[1] === true ? 'active' : ''" type="point"
        class="point tool-toolTip" src="/assets/img/tools/annotation_point.png" /><span *ngIf="
          !checkHtmlEntity(mapService.templatetoolTips['annotator_points'])
        " class="tooltiptext" [innerHtml]="mapService.templatetoolTips['annotator_points']"></span>
    </div>
    <div (click)="drawShapes('LineString', 2)" class="closerToolTip1">
      <img (click)="enableClass(2)" [ngClass]="active[2] === true ? 'active' : ''" type="line"
        class="line tool-toolTip1" src="/assets/img/tools/annotation_line.png" /><span class="tooltiptext1"
        *ngIf="!checkHtmlEntity(mapService.templatetoolTips['annotator_lines'])"
        [innerHtml]="mapService.templatetoolTips['annotator_lines']"></span>
    </div>
    <div (click)="drawShapes('Polygon', 3)" class="closerToolTip2">
      <img (click)="enableClass(3)" [ngClass]="active[3] === true ? 'active' : ''" type="polygon"
        class="polygon tool-toolTip2" src="/assets/img/tools/annotation_polygon.png" />
      <span *ngIf="
          !checkHtmlEntity(mapService.templatetoolTips['annotator_polygons'])
        " class="tooltiptext2" [innerHtml]="mapService.templatetoolTips['annotator_polygons']"></span>
    </div>
    <div class="closerToolTip3">
      <img (click)="enableClass(4)" [ngClass]="active[4] === true ? 'active' : ''" type="polygon"
        class="polygon tool-toolTip3" accept=".kml" src="/assets/img/tools/annotation_upload.png" />
      <span class="tooltiptext3">Add annotation from KMZ/KML file.</span>
    </div>
  </div>

  <!-- color picker custom -->
  <!-- <label
    title="Choose a color for drawing a shape default is orange. On save, the selected color will be shown on drawn annotations."
    class="custom_color_picker">Selected Color <input type="color" (change)="onChangeColor()" [(ngModel)]="selectedColor" [value]="selectedColor"
      name="color" list="presets"></label>
  <datalist id="presets">
    <option value="#FF0000">Red</option>
    <option value="#0000FF">Blue</option>
    <option value="#FFFF00">Yellow</option>
    <option value="#800080">Purple</option>
    <option value="#00FF00">Green</option>
    <option value="#FFA500">Orange</option>
  </datalist> -->


  <!-- https://ngx-colors.web.app/ -->
  <div class="color_picker_main">
    <div
      title="Choose a color for drawing a shape default is orange. On save, the selected color will be shown on drawn annotations."
      class="label_div_color_picker">Select Color</div>
    <div class="color_picker_div">
      <ngx-colors ngx-colors-trigger [palette]="colorPalette" (change)="onChangeColor()" [(ngModel)]="selectedColor"
        [hideColorPicker]="true" [hideTextInput]="true">
      </ngx-colors>
    </div>
  </div>

  <!-- Extension for Annotation -->
  <div class="folder_icon" class="closerToolTip4" id="folder_icon">
    <a class="folder_a">
      <img (click)="openCreateFolderMenu()" id="folder_image" class="folder_image tool-toolTip4"
        src="/assets/img/tools/folder4.png" />
      <span class="tooltiptext4">Create a folder.</span></a>
  </div>


  <!-- *ngIf="createFolder || editFolderModal" -->
  <div class="folder_menu" [hidden]="(!createFolder && !editFolderModal)" id="folder_menu">
    <h3 class="folder_menu_h3">
      {{ !editFolderModal ? "Create Folder" : "Edit Folder" }}
    </h3>
    <input placeholder="Enter title here" type="text" class="folder_input folder_input_title" maxlength="25"
      [(ngModel)]="folder.name" />
    <input placeholder="Enter subtitle here" type="text" class="folder_input folder_input_subtitle" maxlength="50"
      [(ngModel)]="folder.description" />
    <div class="button-wrapper">
      <button class="modal-button-style save_folder" (click)="!editFolderModal ? saveFolder() : editFolder()">
        Save</button><button class="modal-button-style cancel_folder" (click)="cancelFolder()">
        Cancel
      </button>
    </div>
  </div>

  <mat-accordion multi>
    <!-- Points -->
    <mat-expansion-panel #expPanel1 (opened)="openPanel1()" (closed)="closePanel1()" hideToggle="true"
      [expanded]="state['exapandPanel' + 1]">
      <mat-expansion-panel-header class="margin-Btm" (click)="expPanel1.expanded ? checkedList('point') : ''">
        <mat-panel-title class="base"> Points </mat-panel-title>
        <mat-panel-description>
          <mat-icon class="arrow_icon" *ngIf="panelOpenState1">arrow_drop_down</mat-icon>
          <mat-icon class="arrow_icon" *ngIf="!panelOpenState1">arrow_drop_up</mat-icon>
        </mat-panel-description>
      </mat-expansion-panel-header>
      <ng-container *ngFor="let data of sideNavService.annotationData; index as i">
        <div [class.borderMenu]="selectedIndex === i" class="annotation-item ann-li-dehighlight hover"
          *ngIf="data.type === 'point'" id="anno-{{ i }}">
          <div style="width: 100% !important" (click)="activateClass(data.id, i, data, $event)" class="title hover"
            *ngIf="data.name !== ''">
            {{ data.name }}
          </div>
          <div style="width: 100% !important" (click)="activateClass(data.id, i, data, $event)" class="title hover"
            *ngIf="data.name === ''">
            ...
          </div>
          <span class="ann-actions" id="span{{ i }}"><input type="checkbox" [(ngModel)]="data.visible"
              value="{{ data.id }}" (change)="onChange($event)" />
            <img id="showMenu" class="ann-action-btn" src="/assets/img/table/3doticon.png"
              (click)="showMenu(i, $event, data.id)" (click)="getPosition(i)" /></span>
          <ul class="ann-option-buttons" *ngIf="clicked[i]" id="subMenu{{ i }}">
            <div class="available_folder_submenu" *ngIf="availableFolder">
              <li *ngFor="let fdata of sideNavService.folderData; index as t" class="center-feature"
                (click)="moveToFolder(data.id, fdata.id)">
                <span> {{ fdata.title }}</span>
              </li>
              <li class="center-feature">
                <span class="disabled_remove">
                  {{'< Remove>'}}
                </span>
              </li>
            </div>

            <li class="center-feature folderHover" (mouseenter)="showAvailableFolders()">
              <img src="/assets/img/tools/folder4.png" /><span>
                Folder<mat-icon class="right_arrow">keyboard_arrow_right
                </mat-icon></span>
            </li>
            <li class="center-feature" (mouseenter)="hideAvailableFolders()"
              (click)="zoomClickedEnableZoom(data.id, i, data)">
              <img src="/assets/img/tools/zoom-to.png" /><span> Zoom</span>
            </li>
            <li *ngIf="!multiple" class="edit-annotation" (mouseenter)="hideAvailableFolders()"
              (click)="edit(data.id, data.name, data.description,data.annotation_color, data.user_fields)">
              <img src="/assets/img/tools/edit2.png" /><span> Edit</span>
            </li>
            <li *ngIf="!multiple" class="select-annotation" (mouseenter)="hideAvailableFolders()"
            (click)="select(data.id, i, data)">
              <img src="/assets/img/tools/a-select.png" /><span> Select</span>
            </li>
            <li class="delete-confirm-btn" (mouseenter)="hideAvailableFolders()">
              <img src="/assets/img/table/addRedX2.png" /><span (click)="delete()">
                Delete</span>
            </li>
          </ul>
        </div>
      </ng-container>
    </mat-expansion-panel>
    <!-- Lines -->
    <mat-expansion-panel #expPanel2 (opened)="openPanel2()" (closed)="closePanel2()" hideToggle="true"
      [expanded]="state['exapandPanel' + 2]">
      <mat-expansion-panel-header class="margin-Btm" (click)="expPanel2.expanded ? checkedList('line') : ''">
        <mat-panel-title class="base"> Lines </mat-panel-title>
        <mat-panel-description>
          <mat-icon class="arrow_icon" *ngIf="panelOpenState2">arrow_drop_down</mat-icon>
          <mat-icon class="arrow_icon" *ngIf="!panelOpenState2">arrow_drop_up</mat-icon>
        </mat-panel-description>
      </mat-expansion-panel-header>
      <ng-container *ngFor="let data of sideNavService.annotationData; index as i">
        <div [class.borderMenu]="selectedIndex === i" class="annotation-item ann-li-dehighlight hover"
          *ngIf="data.type === 'line'" id="anno-{{ i }}">
          <div style="width: 100% !important" (click)="activateClass(data.id, i, data, $event)" class="title hover"
            *ngIf="data.name !== ''">
            {{ data.name }}
          </div>
          <div style="width: 100% !important" (click)="activateClass(data.id, i, data, $event)" class="title hover"
            *ngIf="data.name === ''">
            ...
          </div>
          <span class="ann-actions" id="span{{ i }}"><input type="checkbox" [(ngModel)]="data.visible"
              value="{{ data.id }}" (change)="onChange($event)" /><img class="ann-action-btn" id="showMenu"
              src="/assets/img/table/3doticon.png" (click)="showMenu(i, $event, data.id)"
              (click)="getPosition(i)" /></span>
          <ul class="ann-option-buttons" *ngIf="clicked[i]" id="subMenu{{ i }}">
            <div class="available_folder_submenu" *ngIf="availableFolder">
              <li *ngFor="let fdata of sideNavService.folderData; index as t" class="center-feature"
                (click)="moveToFolder(data.id, fdata.id)">
                <span> {{ fdata.title }}</span>
              </li>
              <li class="center-feature">
                <span class="disabled_remove">
                  {{'< Remove>'}}
                </span>
              </li>
            </div>

            <li class="center-feature folderHover" (mouseenter)="showAvailableFolders()">
              <img src="/assets/img/tools/folder4.png" /><span>
                Folder<mat-icon class="right_arrow">keyboard_arrow_right
                </mat-icon></span>
            </li>
            <li class="center-feature" (mouseenter)="hideAvailableFolders()"
              (click)="zoomClickedEnableZoom(data.id, i, data)">
              <img src="/assets/img/tools/zoom-to.png" /><span> Zoom</span>
            </li>
            <li *ngIf="!multiple" class="edit-annotation" (mouseenter)="hideAvailableFolders()"
              (click)="edit(data.id, data.name, data.description,data.annotation_color, data.user_fields)">
              <img src="/assets/img/tools/edit2.png" /><span> Edit</span>
            </li>

            <li *ngIf="!multiple" class="select-annotation" (mouseenter)="hideAvailableFolders()"
            (click)="select(data.id, i, data)">
              <img src="/assets/img/tools/a-select.png" /><span> Select</span>
            </li>
            <li class="delete-confirm-btn" (mouseenter)="hideAvailableFolders()">
              <img src="/assets/img/table/addRedX2.png" /><span (click)="delete()">
                Delete</span>
            </li>
          </ul>
        </div>
      </ng-container>
    </mat-expansion-panel>
    <!-- Polygons-->
    <mat-expansion-panel (opened)="openPanel3()" (closed)="closePanel3()" hideToggle="true"
      [expanded]="state['exapandPanel' + 3]" #expPanel3>
      <mat-expansion-panel-header class="margin-Btm" (click)="expPanel3.expanded ? checkedList('polygon') : ''">
        <mat-panel-title class="base"> Polygons </mat-panel-title>
        <mat-panel-description>
          <mat-icon class="arrow_icon" *ngIf="panelOpenState3">arrow_drop_down</mat-icon>
          <mat-icon class="arrow_icon" *ngIf="!panelOpenState3">arrow_drop_up</mat-icon>
        </mat-panel-description>
      </mat-expansion-panel-header>
      <ng-container *ngFor="let data of sideNavService.annotationData; index as i">
        <div [class.borderMenu]="selectedIndex === i" class="annotation-item ann-li-dehighlight hover"
          *ngIf="data.type === 'polygon'" id="anno-{{ i }}">
          <div style="width: 100% !important" (click)="activateClass(data.id, i, data, $event)" class="title hover"
            *ngIf="data.name !== ''">
            {{ data.name }}
          </div>
          <div style="width: 100% !important" (click)="activateClass(data.id, i, data, $event)" class="title hover"
            *ngIf="data.name === ''">
            ...
          </div>
          <span class="ann-actions" id="span{{ i }}"><input type="checkbox" [(ngModel)]="data.visible"
              value="{{ data.id }}" (change)="onChange($event)" /><img class="ann-action-btn"
              src="/assets/img/table/3doticon.png" id="showMenu" (click)="showMenu(i, $event, data.id)"
              (click)="getPosition(i)" /></span>
          <ul class="ann-option-buttons" *ngIf="clicked[i]" id="subMenu{{ i }}">
            <div class="available_folder_submenu" *ngIf="availableFolder">
              <li *ngFor="let fdata of sideNavService.folderData; index as t" class="center-feature"
                (click)="moveToFolder(data.id, fdata.id)">
                <span> {{ fdata.title }}</span>
              </li>
              <li class="center-feature">
                <span class="disabled_remove">
                  {{'< Remove>'}}
                </span>
              </li>
            </div>

            <li class="center-feature folderHover" (mouseenter)="showAvailableFolders()">
              <img src="/assets/img/tools/folder4.png" /><span>
                Folder<mat-icon class="right_arrow">keyboard_arrow_right
                </mat-icon></span>
            </li>
            <li (mouseenter)="hideAvailableFolders()" class="center-feature"
              (click)="zoomClickedEnableZoom(data.id, i, data)">
              <img src="/assets/img/tools/zoom-to.png" /><span> Zoom</span>
            </li>
            <li (mouseenter)="hideAvailableFolders()" *ngIf="!multiple" class="edit-annotation"
              (click)="edit(data.id, data.name, data.description,data.annotation_color, data.user_fields)">
              <img src="/assets/img/tools/edit2.png" /><span> Edit</span>
            </li>
            <li (mouseenter)="hideAvailableFolders()" *ngIf="!multiple" class="select-annotation"
            (click)="select(data.id, i, data)">
              <img src="/assets/img/tools/a-select.png" /><span> Select</span>
            </li>
            <li class="delete-confirm-btn" (mouseenter)="hideAvailableFolders()">
              <img src="/assets/img/table/addRedX2.png" /><span (click)="delete()">
                Delete</span>
            </li>
          </ul>
        </div>
      </ng-container>
    </mat-expansion-panel>
    <!-- Uploads -->
    <mat-expansion-panel #expPanel4 (opened)="openPanel4()" (closed)="closePanel4()" hideToggle="true"
      [expanded]="state['exapandPanel' + 4]">
      <mat-expansion-panel-header class="margin-Btm" (click)="expPanel4.expanded ? checkedList('geomcollection') : ''">
        <mat-panel-title class="base"> Uploads </mat-panel-title>
        <mat-panel-description>
          <mat-icon class="arrow_icon" *ngIf="panelOpenState4">arrow_drop_down</mat-icon>
          <mat-icon class="arrow_icon" *ngIf="!panelOpenState4">arrow_drop_up</mat-icon>
        </mat-panel-description>
      </mat-expansion-panel-header>
      <ng-container *ngFor="let data of sideNavService.annotationData; index as i">
        <div [class.borderMenu]="selectedIndex === i" class="annotation-item ann-li-dehighlight hover"
          *ngIf="data.type === 'geomcollection'" id="anno-{{ i }}">
          <div (click)="activateClass(data.id, i, data, $event)" class="title hover" *ngIf="data.name !== ''"
            style="width: 100% !important">
            {{ data.name }}
          </div>
          <div style="width: 100% !important" (click)="activateClass(data.id, i, data, $event)" class="title hover"
            *ngIf="data.name === ''">
            ...
          </div>
          <span class="ann-actions" id="span{{ i }}"><input type="checkbox" value="{{ data.id }}"
              [(ngModel)]="data.visible" (change)="onChange($event)" /><img class="ann-action-btn"
              src="/assets/img/table/3doticon.png" id="showMenu" (click)="showMenu(i, $event, data.id)"
              (click)="getPosition(i)" /></span>
          <ul class="ann-option-buttons" *ngIf="clicked[i]" id="subMenu{{ i }}">
            <div class="available_folder_submenu" *ngIf="availableFolder">
              <li *ngFor="let fdata of sideNavService.folderData; index as t" class="center-feature"
                (click)="moveToFolder(data.id, fdata.id)">
                <span> {{ fdata.title }}</span>
              </li>
              <li class="center-feature">
                <span class="disabled_remove">
                  {{'< Remove>'}}
                </span>
              </li>
            </div>

            <li class="center-feature folderHover" (mouseenter)="showAvailableFolders()">
              <img src="/assets/img/tools/folder4.png" /><span>
                Folder<mat-icon class="right_arrow">keyboard_arrow_right
                </mat-icon></span>
            </li>
            <li (mouseenter)="hideAvailableFolders()" class="center-feature"
              (click)="zoomClickedEnableZoom(data.id, i, data)">
              <img src="/assets/img/tools/zoom-to.png" /><span> Zoom</span>
            </li>
            <li (mouseenter)="hideAvailableFolders()" *ngIf="!multiple" class="edit-annotation"
              (click)="edit(data.id, data.name, data.description,data.annotation_color, data.user_fields)">
              <img src="/assets/img/tools/edit2.png" /><span> Edit</span>
            </li>
            <li (mouseenter)="hideAvailableFolders()" *ngIf="!multiple" class="select-annotation"
            (click)="select(data.id, i, data)">
              <img src="/assets/img/tools/a-select.png" /><span> Select</span>
            </li>
            <li (mouseenter)="hideAvailableFolders()" class="delete-confirm-btn">
              <img src="/assets/img/table/addRedX2.png" /><span (click)="delete()">
                Delete</span>
            </li>
          </ul>
        </div>
      </ng-container>
    </mat-expansion-panel>

    <!-- Folder System -->

    <mat-expansion-panel class="folder_panel_parent" (opened)="openParentFolder()" (closed)="closeParentFolder()"
      hideToggle="true" [expanded]="state1['exapandPanelParent']">
      <mat-expansion-panel-header class="margin-Btm">
        <mat-panel-title class="base"> Folders </mat-panel-title>
        <mat-panel-description>
          <mat-icon class="arrow_icon" *ngIf="panelOpenState['exapandPanelParent']">arrow_drop_down
          </mat-icon>
          <mat-icon class="arrow_icon" *ngIf="!panelOpenState['exapandPanelParent']">arrow_drop_up
          </mat-icon>
        </mat-panel-description>
      </mat-expansion-panel-header>

      <ng-container *ngFor="let data of sideNavService.folderData; index as i">
        <div id="hover">
          <img class="ann-action-btn-folder" src="/assets/img/table/3doticon.png" id="showFolderExpansionMenu{{ i }}"
            (click)="showFolderMainMenu(i)" (click)="getPositionFolderExpansionMenu(i)" />
          <!--Folder Expansion Menu -->
          <ul class="ann-option-buttons panel_option-buttons" *ngIf="clickedFolder[i]" id="FolderExpansionMenu{{ i }}">
            <li class="edit-annotation" (click)="updateFolder(data.id, data.title, data.sub_title,i)">
              <img src="/assets/img/tools/edit2.png" /><span> Edit</span>
            </li>
            <li class="delete-confirm-btn" (click)="deleteFolder(data.id,i)">
              <img src="/assets/img/table/addRedX2.png" /><span>
                Delete</span>
            </li>
          </ul>
          <div id="editFolder{{i}}">
            <mat-expansion-panel id="folder_expansion_panel" class="folder_expansion_panel"
              (opened)="openFolder(i, data.id)" (closed)="closeFolder(i, data.id)" hideToggle="true"
              [expanded]="state1['exapandPanelId'+  data.id]">

              <mat-expansion-panel-header title="{{data.title}} &#010;{{data.sub_title}}"
                class="margin-Btm folder_header" (click)="
            state1['exapandPanelId' + data.id] ? checkedListFolder(data.name) : ''
          ">

                <mat-panel-title class="base_folder_title">{{
                  data.title
                  }}</mat-panel-title>


                <p class="folder_p">{{data.sub_title===null||data.sub_title?.trim()?.length===0 ?
                  '':data.sub_title }}</p>
                <mat-panel-description>
                  <mat-icon class="arrow_icon arrow_icon_folder" *ngIf="panelOpenState[i]">arrow_drop_down</mat-icon>
                  <mat-icon class="arrow_icon arrow_icon_folder" *ngIf="!panelOpenState[i]">arrow_drop_up</mat-icon>
                </mat-panel-description>
              </mat-expansion-panel-header>
              <ng-container *ngFor="let data1 of data.annotation; index as j">
                <div [class.borderMenu]="selectedIndex === j + sideNavService.annotationData.length * data1.id"
                  class="annotation-item ann-li-dehighlight hover annotation-item-folder"
                  id="anno-{{ j + sideNavService.annotationData.length * data1.id }}">
                  <div
                    (click)="activateClass(data1.id, j + sideNavService.annotationData.length * data1.id, data1, $event,data.id,'yes')"
                    class="title hover annotation_inside_folder" *ngIf="data1.name !== ''"
                    style="width: 100% !important">
                    {{ data1.name }}
                  </div>
                  <div style="width: 100% !important"
                    (click)="activateClass(data1.id, j + sideNavService.annotationData.length * data1.id, data1, $event,data.id,'yes')"
                    class="title hover annotation_inside_folder" *ngIf="data1.name === ''">
                    ...
                  </div>
                  <span class="ann-actions" id="span{{ j + sideNavService.annotationData.length * data1.id }}"><input
                      type="checkbox" value="{{ data1.id }}" [(ngModel)]="data1.visible"
                      (change)="onChangeFolderAnno($event, data.id)" /><img class="ann-action-btn"
                      src="/assets/img/table/3doticon.png" id="showMenu"
                      (click)="showMenu(j + sideNavService.annotationData.length * data1.id, $event, data1.id)"
                      (click)="getPosition(j + sideNavService.annotationData.length * data1.id)" /></span>
                  <ul class="ann-option-buttons" *ngIf="clicked[j + sideNavService.annotationData.length * data1.id]"
                    id="subMenu{{ j + sideNavService.annotationData.length * data1.id }}">
                    <div class="available_folder_submenu" *ngIf="availableFolder">
                      <li *ngFor="let fdata of sideNavService.folderData; index as t" class="center-feature"
                        (click)="data.id !== fdata.id?moveToAnotherFolder(data.id, fdata.id,data1.id):'null'">
                        <span [ngClass]="data.id === fdata.id ? 'disabled' : 'enabled'">
                          {{ fdata.title }}</span>
                      </li>
                      <li class="center-feature" (click)="moveBackTofolderless(null, data.id, data1.id)">
                        <span>
                          {{'< Remove>'}}
                        </span>
                      </li>
                    </div>

                    <li class="center-feature folderHover" (mouseenter)="showAvailableFolders()">
                      <img src="/assets/img/tools/folder4.png" /><span>
                        Folder<mat-icon class="right_arrow">
                          keyboard_arrow_right
                        </mat-icon></span>
                    </li>

                    <li (mouseenter)="hideAvailableFolders()" class="center-feature"
                      (click)="zoomClickedEnableZoom(data1.id, j + sideNavService.annotationData.length * data1.id, data1,data.id,'yes')">
                      <img src="/assets/img/tools/zoom-to.png" /><span> Zoom</span>
                    </li>
                    <li (mouseenter)="hideAvailableFolders()" *ngIf="!multiple" class="edit-annotation"
                      (click)="editFolderBeforeRes(data1.id, data1.name, data1.description,data.id,data1.annotation_color)">
                      <img src="/assets/img/tools/edit2.png" /><span> Edit</span>
                    </li>
                    <li (mouseenter)="hideAvailableFolders()" *ngIf="!multiple" class="select-annotation"
                      (click)="selectFolderAnnotation(data1.id, data1)">
                      <img src="/assets/img/tools/a-select.png" /><span> Select</span>
                    </li>
                    <li class="delete-confirm-btn" (mouseenter)="hideAvailableFolders()">
                      <img src="/assets/img/table/addRedX2.png" /><span (click)="delete()">
                        Delete</span>
                    </li>
                  </ul>
                </div>
              </ng-container>
            </mat-expansion-panel>
          </div>
        </div>
      </ng-container>

    </mat-expansion-panel>
  </mat-accordion>

  <div class="buttonDiv">
    <a class="closer closerToolTip" id="closer">
      <img (click)="closePanel()" (click)="clearBox()" class="closer-img common-btns tool-toolTip"
        src="/assets/img/tools/close-pv3.png" alt="closer" />
      <span class="tooltiptext tip-bottom" [innerHtml]="mapService.templatetoolTips['close_left_panel']"></span>
      <div *ngIf="showDeleteButton" class="multi-delete-view-button" (click)="delete()"><span> Delete</span>
      </div>
    </a>
  </div>
</div>


<app-loader></app-loader>
